import React from 'react';
import { Grid, GridItem } from '@chakra-ui/react';
import Item from './item';
import { motion } from 'framer-motion';

const MotionedGridItem = motion(GridItem);

const GridB = (props) => {
	const items = props?.data.map((item, key) => ({
		rowSpan: key === 0 ? [1, 2] : [1, 1],
		colSpan: key === 0 ? [1, 2] : [1, 1],
		// height: key === 0 ? ['200px', '502px'] : '234px',
		height: key === 0 ? ['200px', '499px'] : '200px',
		img_height: key === 0 ? ['200px', '499px'] : '200px',
		...item,
	}));
	return (
		<Grid
			templateRows={['repeat(4, 1fr)', 'repeat(2, 1fr)']}
			templateColumns={['repeat(1, 1fr)', 'repeat(4, 1fr)']}
			gap={['40px', '40px']}
			px={'20px'}
			pb={'40px'}
			className={'gridb'}
		>
			{items.map((item, index) => (
				<MotionedGridItem
					initial={{ y: index + 1 * 50, opacity: 0 }}
					animate={{ y: 0, opacity: 1 }}
					transition={{
						delay: 0.3,
						default: { duration: 0.25 * index + 1 },
					}}
					key={`grid-b-${index}-${item.id}`}
					rowSpan={item.rowSpan}
					colSpan={item.colSpan}
					className="GridB"
				>
					<Item {...item} />
				</MotionedGridItem>
			))}
		</Grid>
	);
};
export default GridB;
